import type { AllowedEmail, BulkRemoveAllowedEmails, CreateAllowedEmail } from '@inbound/contract';

import { apiSlice } from './api-slice.js';

export const allowlistApi = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getAllowlist: build.query<AllowedEmail[], void>({
      query: () => ({ url: '/allowlist' }),
      providesTags: ['Allowlist'],
    }),

    addAllowedEmail: build.mutation<AllowedEmail, CreateAllowedEmail>({
      query: (body) => ({ url: '/allowlist', method: 'POST', body }),
      invalidatesTags: ['Allowlist'],
    }),

    removeAllowedEmail: build.mutation<{ ok: true }, string>({
      query: (id) => ({ url: `/allowlist/${id}`, method: 'DELETE' }),
      invalidatesTags: ['Allowlist'],
    }),

    // One request for the whole selection rather than a DELETE per row: the
    // lockout guards depend on how many entries are left, so they can only be
    // judged against the complete set. See the contract schema for why.
    removeAllowedEmails: build.mutation<{ removed: number }, BulkRemoveAllowedEmails>({
      query: (body) => ({ url: '/allowlist/bulk-remove', method: 'POST', body }),
      invalidatesTags: ['Allowlist'],
    }),
  }),
});

export const {
  useGetAllowlistQuery,
  useAddAllowedEmailMutation,
  useRemoveAllowedEmailMutation,
  useRemoveAllowedEmailsMutation,
} = allowlistApi;
